import PropTypes from "prop-types";
import { childrenPropType, classNamePropType } from "../../common";

/**
 * PropTypes for CardContainer component
 *
 * @property {React.ReactNode} children - Card content
 * @property {string} [className] - Additional CSS classes
 * @property {boolean} [hoverable] - Enable hover effects
 * @property {function} [onClick] - Click handler callback
 */
export const cardContainerPropTypes = {
  children: childrenPropType,
  className: classNamePropType,
  hoverable: PropTypes.bool,
  onClick: PropTypes.func,
};
